import type { Uuid, EmailAddress } from '@shady-pines/types';
import type { Model } from './model';
import type { User } from './user';

export const Platform = ['iOS', 'Android'] as const;
export type Platform = (typeof Platform)[number];

export const DeviceType = [
  // iOS Devices
  'iPhone 15 Pro Max',
  'iPhone 15 Pro',
  'iPhone 15 Plus',
  'iPhone 15',
  'iPhone 14 Pro Max',
  'iPhone 14 Pro',
  'iPhone 14 Plus',
  'iPhone 14',
  'iPhone 13 Pro Max',
  'iPhone 13 Pro',
  'iPhone 13',
  'iPhone 13 Mini',
  'iPhone SE (3rd gen)',
  'iPad Pro 12.9-inch',
  'iPad Pro 11-inch',
  'iPad Air',
  'iPad Mini',

  // Android Devices
  'Samsung Galaxy S24 Ultra',
  'Samsung Galaxy S24+',
  'Samsung Galaxy S24',
  'Samsung Galaxy S23 Ultra',
  'Samsung Galaxy S23+',
  'Samsung Galaxy S23',
  'Samsung Galaxy Z Fold 5',
  'Samsung Galaxy Z Flip 5',
  'Google Pixel 8 Pro',
  'Google Pixel 8',
  'Google Pixel 7 Pro',
  'Google Pixel 7',
  'OnePlus 12',
  'OnePlus 11',
  'Xiaomi 14 Pro',
  'Xiaomi 14',
  'OPPO Find X7 Pro',
  'OPPO Find X7',
] as const;
export type DeviceType = (typeof DeviceType)[number];

export const Severity = ['low', 'medium', 'high', 'severe'] as const;
export type Severity = (typeof Severity)[number];

export const BugStatus = ['new', 'investigating', 'in_progress', 'resolved', 'wont_fix'] as const;
export type BugStatus = (typeof BugStatus)[number];

export type BugReport = Model<{
  id: Uuid<BugReport>;
  description: string;
  device_type: DeviceType;
  platform: Platform;
  reporter_email: EmailAddress;
  severity: Severity;
  status: BugStatus;
  title: string;
  user_id: Uuid<User> | null;
}>;
